const Company = [
    {
      id: 1,
      name: "Cross Ocean Travel & Tours",
      address: "Wellesley House 102-Cranbrook Road Ilford",
      address2 : "London IG1 4NH",
      website :"www.crossoceantravel.co.uk",
      bankTitle : "Cross Ocean Travel & Tours",
      AccountNo :"47 90 56 88",
      SortCode : "04-00-03",
      complainEmail :"complaint@crossoceantravel.co.uk"

    },
];

export default Company;